<div class="page-content">
  <!-- Not currently shown — duplicated the shared top header's title/subtitle.
  <div class="content-head">
    <div>
      <div class="eyebrow">EMPLOYER RELATIONSHIPS</div>
      <h2>Companies & Jobs</h2>
      <p>Manage hiring partners, open roles, and campus recruitment drives.</p>
    </div>
  </div>
  -->

  <!-- Summary Row (4 stat cards) -->
  <div class="summary-row">
    <div class="summary-card">
      <strong>{{ stats?.active_companies ?? '—' }}</strong>
      <span>Active companies</span>
    </div>
    <div class="summary-card">
      <strong>{{ stats?.open_positions ?? '—' }}</strong>
      <span>Open positions</span>
    </div>
    <!-- Not currently shown — applications-this-month stat.
    <div class="summary-card">
      <strong>{{ stats?.applications_this_month ?? '—' }}</strong>
      <span>Applications this month</span>
    </div>
    -->
    <div class="summary-card">
      <strong>{{ stats?.active_drives ?? '—' }}</strong>
      <span>Active drives</span>
    </div>
  </div>

  <!-- Job Opportunities Panel -->
  <section class="panel">
    <div class="panel-heading">
      <h2>Job opportunities</h2>
    </div>

    <!-- Toolbar -->
    <div class="toolbar">
      <div class="search-box">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input
          type="text"
          [(ngModel)]="query"
          (ngModelChange)="onSearchInput()"
          placeholder="Search companies or roles..." />
      </div>

      <div class="search-box">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
        <input
          type="text"
          [(ngModel)]="locationQuery"
          (ngModelChange)="onSearchInput()"
          placeholder="Filter by location..." />
      </div>

      <!-- Course filtering now comes from the shared header's Department
      selector instead of a second dropdown here.

      Not currently shown — deadline and status filters.
      <app-custom-select
        [value]="deadlineFilter"
        [options]="deadlineOptions"
        iconType="filter"
        (valueChange)="onDeadlineChange($event)">
      </app-custom-select>

      <app-custom-select
        [value]="statusFilter"
        [options]="statusOptions"
        iconType="list"
        (valueChange)="onStatusChange($event)">
      </app-custom-select>
      -->
    </div>

    <!-- Table -->
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Company & role</th>
            <th>Eligible programs</th>
            <th>Location</th>
            <th>Applicants</th>
            <!-- Not currently shown — deadline and status columns.
            <th>Deadline</th>
            <th>Status</th>
            -->
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let job of jobs"
            (click)="onJobClick(job)"
            class="clickable-row">
            <td>
              <div class="person-cell">
                <div class="company-logo table-logo" [class.has-img]="job.company_logo_url">
                  <img *ngIf="job.company_logo_url" [src]="job.company_logo_url" alt="" />
                  <ng-container *ngIf="!job.company_logo_url">{{ job.company_name.charAt(0) }}</ng-container>
                </div>
                <div>
                  <strong>{{ job.company_name }}</strong>
                  <span>{{ job.role }}</span>
                </div>
              </div>
            </td>
            <td>{{ job.eligible_programs.length ? job.eligible_programs.join(', ') : '—' }}</td>
            <td>{{ job.location || '—' }}</td>
            <td><strong>{{ job.applicants }}</strong></td>
            <!-- Not currently shown — deadline and status columns.
            <td>{{ job.deadline ? (job.deadline | date: 'mediumDate') : '—' }}</td>
            <td>
              <span class="status-pill" [ngClass]="job.status === 'Applications Open' ? 'success' : 'warning'">
                {{ job.status }}
              </span>
            </td>
            -->
            <td>
              <svg class="row-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </td>
          </tr>
          <tr *ngIf="!isLoading && jobs.length === 0">
            <td colspan="5" class="empty-cell">No opportunities match your criteria.</td>
          </tr>
          <tr *ngIf="isLoading">
            <td colspan="5" class="empty-cell">Loading job opportunities…</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="total > 0">
      <span>Showing {{ jobs.length }} of {{ total }} active opportunities</span>
      <div class="page-buttons">
        <button
          type="button"
          *ngFor="let p of pageNumbers"
          [class.current]="p === page"
          (click)="goToPage(p)">
          {{ p }}
        </button>
        <button type="button" aria-label="Next page" [disabled]="page >= totalPages" (click)="goToPage(page + 1)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    </div>
  </section>
</div>
